export const cartesianProduct = arr => {
  return arr.reduce(
    (a, b) =>
      a
        .map(x => b.map(y => x.concat([y])))
        .reduce((a, b) => a.concat(b), []),
    [[]]
  );
};

export const arraysEqual = (a, b) => {
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  return a.every((val, index) => val === b[index]);
};

export const filterEmptyValues = (options) => {
  return options.map(option => ({
    ...option,
    values: option.values.filter(val => val.name.trim() !== '')
  }));
};

export const isSubset = (a, b) => {
  if (!a || !b) return false;
  return a.every(val => b.includes(val));
};

export const formatNumber = (num) => {
  if (typeof num === 'string') {
    const parsed = parseFloat(num);
    if (isNaN(parsed)) {
      return num;
    }
    return parsed % 1 === 0 ? Math.floor(parsed).toString() : parsed.toString();
  }

  if (typeof num === 'number') {
    return num % 1 === 0 ? Math.floor(num).toString() : num.toString();
  }

  return num;
};

export const generateVariants = (options, variants, setVariants, canAddVariants, opts) => {
  // Filter out empty values from each option before calculating cartesian product
  const optionsWithValidValues = options.map(opt => ({
    ...opt,
    values: opt.values.filter(val => val.name && val.name.trim() !== '')
  })).filter(opt => opt.values.length > 0); // Also filter out options with no valid values

  if (optionsWithValidValues.length === 0) {
    setVariants([]);
    return;
  }

  const combinations = cartesianProduct(optionsWithValidValues.map(opt => opt.values));
  if (combinations.length > 0) {
    const matchedVariants = new Set();
    const newVariants = combinations
      .map(combination => {
        const valueIds = combination.map(val => val.id);
        const combinationString = combination.map(val => val.name).join(" / ");

        const existingVariant = variants.find(
          variant => isSubset(variant.valueIds, valueIds) || isSubset(valueIds, variant.valueIds) && !matchedVariants.has(variant.id)
        );
        if (existingVariant) {
          matchedVariants.add(existingVariant.id);
          let newLabel;
          let faceValue = existingVariant.faceValue;
          if (canAddVariants || opts['reward_type'] === 'discrete_type') {
            newLabel = existingVariant.label;
          } else if (opts['reward_type'] === 'variable_type') {
            newLabel = opts['currency_symbol'] + combinationString;
            faceValue = combinationString
          } else {
            newLabel = combinationString;
          }
          return {
            ...existingVariant,
            label: newLabel,
            faceValue: formatNumber(faceValue),
            valueIds
          };
        }
        const uniqueId = generateId();
        let label;
        let faceValue;
        if (opts['reward_type'] === 'variable_type') {
          label = opts['currency_symbol'] + combinationString;
          faceValue = combinationString
        } else {
          label = combinationString;
          faceValue = 0;
        }
        return {
          id: uniqueId,
          valueIds,
          label: label,
          faceValue: formatNumber(faceValue),
          quantity: null,
          sku: null,
          image: null,
          enabled: true,
          providerRewardVariantId: opts?.provider_variant_id
        };
    });
    setVariants(newVariants);
  } else {
    setVariants([]);
  }
};

export const REWARD_TYPES = {
  COMPANY_FULFILLED: 'company_fulfilled',
  AXOMO_REWARD: 'axomo_reward',
  VARIABLE_TYPE: 'variable_type',
  DISCRETE_TYPE: 'discrete_type'
};

export const hasVariantsWithQuantity = (opts) => {
  return opts.reward_type === REWARD_TYPES.COMPANY_FULFILLED && opts.has_variants_with_quantity;
};

export const hasPricingAndQuantityFields = (opts) => {
  return opts.reward_type === REWARD_TYPES.COMPANY_FULFILLED || opts.reward_type === REWARD_TYPES.AXOMO_REWARD;
}

export const generateId = () => {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
};